import {actions} from "../actions/actionTypes";

export const initialState = {
    alert: {visible: false, icon: "", text: "", alertType: ""}
    }

export default (state = initialState, action) => {
    switch (action.type){
        case actions.SET_ALERT:
                return {
                ...state,
                alert : action.alert
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/redurcers/alertReducer.js